import { CloseTwoTone } from '@mui/icons-material';
import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FilterValues, OnlineToursFilters } from './OnlineToursFilters';

type OnlineTourTypeFilterProps = {
  open: boolean;
  onClose: () => void;
  initialFilterValues: FilterValues;
  onSearch: (filterValues: FilterValues) => void;
};

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function OnlineToursFilterDialog({
  open,
  onClose,
  initialFilterValues,
  onSearch,
}: OnlineTourTypeFilterProps) {
  const { t } = useTranslation();
  const [control, setControl] = useState(false);

  const handleSearch = (filterValues: FilterValues) => {
    onSearch(filterValues);
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen
      TransitionComponent={Transition}
    >
      <DialogTitle
        sx={{
          position: 'relative',
        }}
      >
        {t('onlineTourFiltering.filter')}
        <IconButton
          onClick={onClose}
          sx={{ position: 'absolute', right: 8, top: 8 }}
        >
          <CloseTwoTone />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <OnlineToursFilters
          initialFilterValues={initialFilterValues}
          onSearch={handleSearch}
          control={control}
          setControl={setControl}
        />
      </DialogContent>
    </Dialog>
  );
}
